import { CMSSection } from '@/features/cms/components/CMS/CMSSection'
import { type CMSPageDataWithSpecificLayout } from '@/features/cms/components/CMS/types'
import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { spacingRem } from '@/features/shared/theme/tokens'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { useCMSParamsWithoutSlug } from '@/features/cms/services/CMS/hooks'
import { Footer } from '@/features/shared/components/Footers/Footer'

/**
 * This component corresponds to the `marketplace_page_layout` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/marketplace_page_layout
 * - **Production** - https://cms.shipt.com/content-type/pool/marketplace_page_layout
 */
export const MarketplacePageLayout = ({
  layoutData: { id, content_type_id, data },
}: {
  layoutData: CMSPageDataWithSpecificLayout<'marketplace_page_layout'>['content']
}) => {
  const params = useCMSParamsWithoutSlug()
  const isHeaderBanner =
    data?.body?.some((item, i) => item.content_type_id === 'header_banner' && i === 0) || false
  return (
    <>
      <MarketplacePageLayoutContainer
        // carousels can persist consistent data in the UI tree on shelf driven pages
        // causing only children to re-render instead of entire carousel
        key={params.addressParams?.address_line_1}
        shouldNotAddMargin={isHeaderBanner}
        {...getCMSWrapperProps({ content_type_id, id })}
      >
        {!!data?.body && <CMSSection section={data.body} />}
      </MarketplacePageLayoutContainer>
      {data?.footer ? <CMSSection section={data.footer} /> : <Footer />}
    </>
  )
}

const MarketplacePageLayoutContainer = styled.div<{
  shouldNotAddMargin: boolean
}>`
  margin-top: ${({ shouldNotAddMargin }) => (shouldNotAddMargin ? 0 : spacingRem('lg'))};

  @media ${screenSizes.tablet} {
    margin-top: ${({ shouldNotAddMargin }) => (shouldNotAddMargin ? 0 : spacingRem('xl'))};
  }

  @media ${screenSizes.smDesktop} {
    margin-top: ${spacingRem('xl')};
  }
`
